import "core-js/modules/es6.regexp.search";
import "core-js/modules/es6.regexp.match";
import "core-js/modules/es6.regexp.constructor";
import _toConsumableArray from "/data/jenkins/workspace/saas-prod_cp-fe-bms-web/node_modules/@babel/runtime-corejs2/helpers/esm/toConsumableArray";
import "core-js/modules/web.dom.iterable";

/*
 * @Descripttion: file content
 * @Author: zc
 * @Date: 2020-05-26 13:24:24
 * @LastEditors: zc
 * @LastEditTime: 2024-10-31 17:44:44
 */
import Vue from 'vue';
import Router from 'vue-router';
import store from '@/store/index';
import { loginUrl } from '@/config';
import NProgress from 'nprogress'; // progress bar

import 'nprogress/nprogress.css'; // progress bar style

import getPageTitle from '@/utils/get-page-title';
import { getToken, getSessionToken, setSessionToken } from '@/utils/auth';
Vue.use(Router); // 所有路由数组

var routes = []; // 动态加载路由

var modulesFiles = require.context('./modules', true, /\.js$/);

modulesFiles.keys().map(function (modulePath) {
  var value = modulesFiles(modulePath); //判断是否为数组路由

  if (value.default.length || value.default.length === 0) {
    routes.push.apply(routes, _toConsumableArray(value.default));
  } else {
    routes.push(value.default);
  }
});
/*
 * 创建路由
 */

var createRouter = function createRouter() {
  return new Router({
    routes: routes
  });
};

var router = createRouter();
NProgress.configure({
  showSpinner: false
}); // NProgress Configuration
// 获取url参数

function getUrlParams(name) {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
  var r = window.location.search.substr(1).match(reg);
  if (r != null) return unescape(r[2]);
  return null;
}

router.beforeEach(function (to, from, next) {
  // start progress bar
  NProgress.start(); // set page title

  document.title = getPageTitle(to.meta.title); // let hasToken = getToken();

  var hasSessionToken = getSessionToken(); // 是否三方登录

  if (getUrlParams('appid') != null && getUrlParams('code') != null && to.path === '/login') {
    next('/logintx');
  } else {
    if (to.path == '/login') {
      if (hasSessionToken) {
        next('/setting');
      } else {
        next();
      }
    } else {
      if (hasSessionToken || to.path == '/retrieval' || to.path == '/phoneRetrieval' || to.path == '/certificateRetrieval' || to.path == '/logintx' || to.path == '/authorize') {
        next();
      } else {
        next('/login');
      }
    }
  } // if (to.path === '/') {
  //   if (hasToken) {
  //     next('/setting');
  //   } else {
  //     next('/login');
  //   }
  // } else {
  //   // 是否腾讯登录
  //   if (getUrlParams('appid') != null && getUrlParams('code') != null && to.path === '/login') {
  //     next('/logintx');
  //   } else {
  //     next();
  //   }
  // }


  NProgress.done();
});
router.afterEach(function () {
  NProgress.done();
}); //export resetRouter

export function resetRouter() {
  var newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
} //export routes

export { routes }; //export default router

export default router;